document.addEventListener('DOMContentLoaded',()=>{
 document.querySelectorAll('form[action*="/contact"]').forEach(form=>form.addEventListener('submit',()=>{const items=window.homarBrief?.load()||[];const field=form.querySelector('[data-contact-concepts]');if(field)field.value=items.map(item=>item.name+' / '+item.config).join('\n')}));
 document.querySelectorAll('[data-native-save]').forEach(button=>button.onclick=()=>{const select=document.querySelector('#homar-variant');const config=button.dataset.config+(select?' / '+select.selectedOptions[0].textContent:'');const items=window.homarBrief?.load()||[];if(!items.some(item=>item.name===button.dataset.name&&item.config===config)&&items.length<30){items.push({name:button.dataset.name,config});window.homarBrief?.save(items)}document.querySelector('[data-native-save-status]').textContent='Added to your project brief.'});
 const receipt=document.querySelector('.homar-form-success,[role="alert"]');const receiptDialog=receipt?.closest('dialog');if(receiptDialog&&!receiptDialog.open)receiptDialog.showModal();
});
/* Native scrolling and dialog keep product images usable without a carousel dependency. */
(() => {
  function setup(scope = document) {
    scope.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      if (gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady = 'true';
      const track = gallery.querySelector('[data-gallery-track]');
      const views = [...gallery.querySelectorAll('[data-gallery-open]')];
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      if (!views.length || !dialog) return;
      const count = gallery.querySelector('[data-gallery-count]');
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const full = dialog.querySelector('[data-gallery-full]');
      const caption = dialog.querySelector('[data-gallery-caption]');
      const dialogPrev = dialog.querySelector('[data-gallery-dialog-prev]');
      const dialogNext = dialog.querySelector('[data-gallery-dialog-next]');
      let current = 0, enlarged = 0, opener, previousOverflow, frame;
      const pad = number => String(number).padStart(2, '0');
      function update(index) {
        current = Math.max(0, Math.min(views.length - 1, index));
        if (count) count.textContent = `${pad(current + 1)} / ${pad(views.length)}`;
        if (prev) prev.disabled = current === 0;
        if (next) next.disabled = current === views.length - 1;
      }
      function scrollTo(index) {
        const target = views[Math.max(0, Math.min(views.length - 1, index))].closest('figure');
        track.scrollTo({ left: track.scrollLeft + target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
      }
      function show(index) {
        enlarged = Math.max(0, Math.min(views.length - 1, index));
        const view = views[enlarged];
        full.src = view.dataset.gallerySrc;
        full.alt = view.dataset.galleryAlt;
        caption.textContent = `${pad(enlarged + 1)} / ${pad(views.length)} — ${view.dataset.galleryAlt}`;
        dialogPrev.disabled = enlarged === 0;
        dialogNext.disabled = enlarged === views.length - 1;
      }
      views.forEach((view, index) => view.addEventListener('click', () => {
        opener = view;
        show(index);
        if (!dialog.open) {
          previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          dialog.showModal();
          dialog.querySelector('[data-gallery-close]').focus();
        }
      }));
      dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow; if (opener?.isConnected) opener.focus({ preventScroll: true }); });
      dialogPrev.addEventListener('click', () => show(enlarged - 1));
      dialogNext.addEventListener('click', () => show(enlarged + 1));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(enlarged + (event.key === 'ArrowLeft' ? -1 : 1)); }
      });
      prev?.addEventListener('click', () => scrollTo(current - 1));
      next?.addEventListener('click', () => scrollTo(current + 1));
      track.addEventListener('keydown', event => {
        if (event.target === track && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) { event.preventDefault(); scrollTo(current + (event.key === 'ArrowLeft' ? -1 : 1)); }
      });
      track.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = null;
          const left = track.getBoundingClientRect().left;
          const distances = views.map(view => Math.abs(view.closest('figure').getBoundingClientRect().left - left));
          update(distances.indexOf(Math.min(...distances)));
        });
      }, { passive: true });
      update(0);
    });
  }
  document.addEventListener('DOMContentLoaded', () => setup());
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-gallery-dialog][open]')?.close());
})();
